import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { useLlmView } from '@websolutespa/bom-mixer-llm';
import style from './page-trigger.module.scss';

export const PageTrigger: React.FC = () => {
  const label = useLabel();
  const { open } = useLlmView(state => state.actions);
  return (
    <button type="button" className={getClassNames(style.trigger, '-trigger')} onClick={() => open()} aria-label="Open assistant">
      <div className={style.icon} />
    </button>
  );
};
